<template>
  <section class="workflow">
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div>
      <locations-list @location-change="(companyUuid) => handleLocationChange(companyUuid)" />
    </div>
    <div v-if="$store.state.locationsList.length">
      <div class="columns">
        <div class="column is-12 mt-2 mb-4 p-0">
          <p>Create a custom workflow to add steps or grand tenant more time</p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12 is-paddingless">
          <div
            v-for="(wf_chunk, idx_chunk) in list"
            :key="'chunk' + idx_chunk"
          >
            <div class="columns">
              <div
                v-for="(wf, idx) in wf_chunk"
                :key="idx"
                class="column is-one-quarter-desktop"
              >
                <div
                  v-if="wf.last_element"
                  class="card"
                >
                  <!-- Last element, we put button to add new workflow -->
                  <div
                    class="card-content"
                    style="display: flex; align-items: center; justify-content: center"
                  >
                    <div class="content has-text-centered">
                      <button
                        class="button primary"
                        @click="handleAddClick"
                      >
                        Create new Workflow
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="card"
                >
                  <header class="card-header">
                    <h6 class="card-header-title is-primary-border has-text-weight-bold">
                      {{ wf.name }}
                    </h6>
                    <div class=" card-header-icon">
                      <div class="dropdown">
                        <div class="dropdown-trigger">
                          <button
                            class="button is-white"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                          >
                            <span class="icon is-small">
                              <i
                                class="fas fa-ellipsis-v"
                                aria-hidden="true"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          id="dropdown-menu"
                          class="dropdown-menu"
                          role="menu"
                        >
                          <div class="dropdown-content">
                            <button
                              class="dropdown-item"
                              @click="handleEditClick(wf.uuid)"
                            >
                              Edit
                            </button>
                            <hr class="dropdown-divider">
                            <button
                              class="dropdown-item"
                              @click="showDeleteModal(wf.uuid)"
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                  <div class="card-content">
                    <div class="content">
                      <i
                        class="fas fa-list-ul fa-fw"
                        aria-hidden="true"
                      /> {{ wf.steps_number }} steps<br>
                      <i
                        class="far fa-clock fa-fw "
                        aria-hidden="true"
                      /> {{ wf.total_duration }} days
                    </div>
                  </div>
                  <footer class="card-footer">
                    <a
                      v-if="wf.is_default == 0"
                      href="#"
                      class="button is-white is-info is-outlined is-borderless"
                      @click="showDefaultModal(wf.uuid)"
                    >Set as default</a>
                    <span
                      v-else
                      class="button is-outlined is-borderless is-success"
                      style="pointer-events: none"
                    ><i class="fas fa-check-circle fa-fw" /> &nbsp; Default</span>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal"
        :class="{'is-active' : show_modal_default}"
      >
        <div
          class="modal-background"
          @click="hideDefaultModal()"
        />
        <div class="modal-content">
          <div class="box">
            <h6>Enable default workflow?</h6>
            <p>This workflow will be applied to all future procedures</p>
            <p
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <a
                href="#"
                class="button is-white"
                @click="hideDefaultModal()"
              >Cancel</a>
              <a
                href="#"
                class="button primary is-outlined"
                @click="setDefault(uuid_default)"
              >Confirm</a>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideDefaultModal()"
        />
      </div>
      <div
        class="modal"
        :class="{'is-active' : show_modal_delete}"
      >
        <div
          class="modal-background"
          @click="hideDeleteModal()"
        />
        <div class="modal-content">
          <div class="box">
            <h6>Delete the workflow?</h6>
            <p>This workflow will be deleted. This action can't be undone</p>
            <p
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <a
                href="#"
                class="button is-white"
                @click="hideDeleteModal()"
              >Cancel</a>
              <a
                href="#"
                class="button is-danger is-outlined"
                @click="setDelete(uuid_delete)"
              >Confirm</a>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideDeleteModal()"
        />
      </div>
    </div>
    <div v-else>
      <div class="no-data card">
        <header class="card-header">
          <p>No Data Available</p>
        </header>
      </div>
    </div>
  </section>
</template>
<script>
import { Routes } from '../../constants';
import LocationsList from '../location/LocationsList.vue';
import WorkflowService from '../../services/workflow.service';

const workflowService = new WorkflowService();
export default {
  name: 'WorkflowList',
  components: {
    LocationsList
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.includes(Routes.WORKFLOW.path)) {
      localStorage.setItem('lastSelectedLocationUuid', this.lastSelectedLocationUuid);
    }
    next();
  },
  data() {
    return {
      selectedOrganizationUuid: null,
      raw_list: [],
      list: [],
      state_name: '',
      uuid_legal_workflow: '',
      show_modal_default: false,
      show_modal_delete: false,
      uuid_default: '',
      uuid_delete: '',
      lastSelectedLocationUuid: null
    };
  },
  computed: {
    locationsList() {
      return this.$store.state.locationsList;
    }
  },
  mounted() {
    const organization = this.$store.state.organization || {};
    this.selectedOrganizationUuid = organization && Object.keys(organization).length ? organization.uuid : '';
    this.$root.pageTitle = 'Lien workflow configuration panel';
  },
  methods: {
    getWorkflow(companyUuid) {
      if (!companyUuid) {
        return;
      }
      const self = this;
      workflowService.getWorkflowList(companyUuid)
        .then((response) => {
          const { status, result } = response.data;

          if (status === 'success') {
            const { list } = result;
            list.push({ last_element: 1 });
            self.raw_list = list;
            self.list = self.chunk(list, 4);
            self.state_name = result.state_name;
            self.uuid_legal_workflow = result.uuid_legal_workflow;
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    chunk(arr, chunk) {
      let i; let j; const temp = [];
      for (i = 0, j = arr.length; i < j; i += chunk) {
        temp.push(arr.slice(i, i + chunk));
      }
      return temp;
    },
    handleEditClick(uuid) {
      this.$router.push({ path: `/workflow/edit/${uuid}` });
    },
    handleAddClick() {
      this.$router.push({ path: '/workflow/add' });
    },
    setDefault(uuid) {
      const self = this;
      const data = new FormData();
      data.append('uuid_workflow', uuid);
      workflowService.setDefaultWorkflow(this.$store.state.company.uuid, data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.raw_list.forEach((el) => {
              if (el.last_element !== 1) {
                el.is_default = 0;
              }
              if (el.uuid === uuid) {
                el.is_default = 1;
              }
            });
            self.list = self.chunk(self.raw_list, 4);
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 10000 } });
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
          self.hideDefaultModal();
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          self.hideDefaultModal();
        });
    },
    showDefaultModal(uuid) {
      this.uuid_default = uuid;
      this.show_modal_default = true;
    },
    hideDefaultModal() {
      this.uuid_default = '';
      this.show_modal_default = false;
    },
    setDelete(uuid) {
      const self = this;
      workflowService.deleteWorkflow(uuid)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            // @todo use .forEach instead
            // eslint-disable-next-line no-plusplus
            for (let idx = 0; idx < self.raw_list.length; idx++) {
              if (self.raw_list[idx].uuid === uuid) {
                self.raw_list.splice(idx, 1);
                idx = self.raw_list.length;
              }
            }
            self.list = self.chunk(self.raw_list, 4);
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 10000 } });
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
          self.hideDeleteModal();
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          self.hideDeleteModal();
        });
    },
    showDeleteModal(uuid) {
      this.uuid_delete = uuid;
      this.show_modal_delete = true;
    },
    hideDeleteModal() {
      this.uuid_delete = '';
      this.show_modal_delete = false;
    },
    handleLocationChange(companyUuid) {
      this.lastSelectedLocationUuid = companyUuid;
      this.getWorkflow(companyUuid);
    }
  }
};
</script>
<style scoped lang="scss">
    .workflow {
        .card {
            height: 100%;
            display: flex;
            flex-direction: column;

            .card-content {
                height: 100%;
                padding-top: 3rem;
                padding-bottom: 2.5rem;
                line-height: 2rem;
            }

            .card-header-title {
                border-left-width: 4px;
                border-left-style: solid;
            }

            .card-footer {
                text-align: right;
                display: block;
                padding: 1rem;
            }

            &.no-data {
                align-items: center;
                padding: 15px 0;
            }
        }

        .is-borderless {
            border: 0;
        }
    }
</style>
